module.exports = __webpack_public_path__ + "img/heart.09f549af.gif";